import { round } from 'lodash-es';

export const formatNumber = (number: number): string => {
  if (number >= 1000000) return `${round(number / 1000000, 2)}M`;
  if (number >= 1000) return `${round(number / 1000, 2)}K`;
  return `${number}`;
};
